// "use client";
// import { useState } from "react";

// const CTABanner = () => {
//   const [hoveredButton, setHoveredButton] = useState(null);

//   return (
//     <section
//       className="relative py-20 px-6 sm:px-8 lg:px-10 overflow-hidden"
//       style={{
//         background: "linear-gradient(135deg, #4FA0FF 0%, #3B8FE8 50%, #2E7DD6 100%)",
//       }}
//     >
//       <div className="max-w-5xl mx-auto relative z-10">
//         <div
//           className="backdrop-blur-md rounded-3xl p-6 sm:p-12 border shadow-2xl"
//           style={{
//             background: "rgba(255, 255, 255, 0.12)",
//             borderColor: "rgba(255, 255, 255, 0.18)",
//             animation: "fadeInScale 0.8s ease-out",
//           }}
//         >
//           <div className="text-center mb-10">
//             <div
//               className="inline-flex items-center px-5 py-2 rounded-full mb-6 relative overflow-hidden"
//               style={{
//                 background: "rgba(29, 53, 87, 0.9)",
//                 border: "2px solid rgba(255, 215, 0, 0.5)",
//                 animation: "slideDown 0.8s ease-out",
//               }}
//             >
//               <span
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   left: "-100%",
//                   width: "100%",
//                   height: "100%",
//                   background: "linear-gradient(90deg, transparent, rgba(255,215,0,0.3), transparent)",
//                   animation: "shimmer 3s infinite",
//                 }}
//               />
//               <svg
//                 className="w-4 h-4 mr-2"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//                 style={{ color: "#FFD700" }}
//               >
//                 <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" />
//               </svg>
//               <span className="text-white text-sm font-bold tracking-wider">
//                 INSTANT CASH
//               </span>
//             </div>

//             <h2
//               className="text-4xl sm:text-5xl font-bold text-white mb-5 leading-tight"
//               style={{
//                 animation: "fadeInUp 0.8s ease-out 0.2s backwards",
//                 textShadow: "0 4px 20px rgba(0,0,0,0.2)",
//               }}
//             >
//               Need Immediate Funds?
//               <br />
//               <span style={{ color: "#FFD700" }}>We Can Help!</span>
//             </h2>

//             <p
//               className="text-lg sm:text-xl max-w-3xl mx-auto"
//               style={{
//                 color: "rgba(255, 255, 255, 0.95)",
//                 animation: "fadeInUp 0.8s ease-out 0.4s backwards",
//                 lineHeight: "1.7",
//               }}
//             >
//               Get funds directly in your bank within minutes through our secure,
//               100% digital process.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {/* How It Works Card */}
//             <div
//               className="rounded-2xl p-7 border relative overflow-hidden"
//               style={{
//                 background: "rgba(29, 53, 87, 0.4)",
//                 borderColor: "rgba(29, 53, 87, 0.6)",
//                 animation: "slideInLeft 0.8s ease-out 0.6s backwards",
//                 backdropFilter: "blur(10px)",
//               }}
//             >
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "-50%",
//                   right: "-50%",
//                   width: "200px",
//                   height: "200px",
//                   borderRadius: "50%",
//                   background: "radial-gradient(circle, rgba(79,160,255,0.15) 0%, transparent 70%)",
//                 }}
//               />

//               <h3 className="text-2xl font-bold text-white mb-5 flex items-center">
//                 <svg
//                   className="w-7 h-7 mr-3"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                   style={{ color: "#FFD700" }}
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                 </svg>
//                 How It Works
//               </h3>

//               <ul className="space-y-4 relative z-10">
//                 {[
//                   "Complete simple online form",
//                   "Get instant approval decision",
//                   "Receive funds in your account"
//                 ].map((text, index) => (
//                   <li
//                     key={index}
//                     className="flex items-start group"
//                     style={{
//                       animation: `fadeInLeft 0.6s ease-out ${0.8 + index * 0.15}s backwards`,
//                     }}
//                   >
//                     <span
//                       className="rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-0.5 flex-shrink-0 font-bold transition-all duration-300 group-hover:scale-110"
//                       style={{
//                         background: "linear-gradient(135deg, #FFD700 0%, #FFC700 100%)",
//                         color: "#1D3557",
//                         boxShadow: "0 4px 12px rgba(255, 215, 0, 0.4)",
//                       }}
//                     >
//                       {index + 1}
//                     </span>
//                     <span
//                       className="text-lg transition-all duration-300 group-hover:translate-x-1"
//                       style={{ color: "rgba(255, 255, 255, 0.95)" }}
//                     >
//                       {text}
//                     </span>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* CTA Card */}
//             <div
//               className="rounded-2xl p-7 border relative overflow-hidden"
//               style={{
//                 background: "rgba(255, 255, 255, 0.08)",
//                 borderColor: "rgba(255, 255, 255, 0.15)",
//                 animation: "slideInRight 0.8s ease-out 0.6s backwards",
//                 backdropFilter: "blur(10px)",
//               }}
//             >
//               <div
//                 style={{
//                   position: "absolute",
//                   bottom: "-50%",
//                   left: "-50%",
//                   width: "200px",
//                   height: "200px",
//                   borderRadius: "50%",
//                   background: "radial-gradient(circle, rgba(255,215,0,0.12) 0%, transparent 70%)",
//                 }}
//               />

//               <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
//                 <svg
//                   className="w-7 h-7 mr-3"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                   style={{ color: "#FFD700" }}
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//                 Ready to Apply?
//               </h3>

//               <div className="space-y-4 relative z-10">
//                 <a
//                   href="/apply-now"
//                   className="w-full font-bold rounded-xl shadow-lg transition-all duration-300 relative overflow-hidden group block"
//                   style={{
//                     background: "linear-gradient(135deg, #FFD700 0%, #FFC700 100%)",
//                     color: "#1D3557",
//                     animation: "fadeInUp 0.6s ease-out 1s backwards",
//                     textDecoration: "none",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     minHeight: "56px",
//                     padding: "16px 32px",
//                   }}
//                   onMouseEnter={() => setHoveredButton('primary')}
//                   onMouseLeave={() => setHoveredButton(null)}
//                 >
//                   <span
//                     className="absolute inset-0 transition-opacity duration-300"
//                     style={{
//                       background: "linear-gradient(135deg, #FFC700 0%, #FFB700 100%)",
//                       opacity: hoveredButton === 'primary' ? 1 : 0,
//                     }}
//                   />
//                   <span className="relative z-10 flex items-center justify-center text-lg">
//                     <svg
//                       className="w-5 h-5 mr-2 transition-transform duration-300 group-hover:translate-x-1 flex-shrink-0"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
//                     </svg>
//                     <span>Get Started Now</span>
//                   </span>
//                 </a>

//                 <a
//                   href="#contact"
//                   className="w-full border-2 font-bold rounded-xl transition-all duration-300 relative overflow-hidden group block"
//                   style={{
//                     borderColor: "rgba(255, 255, 255, 0.9)",
//                     background: "transparent",
//                     color: "white",
//                     animation: "fadeInUp 0.6s ease-out 1.15s backwards",
//                     textDecoration: "none",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     minHeight: "56px",
//                     padding: "16px 32px",
//                   }}
//                   onMouseEnter={() => setHoveredButton('secondary')}
//                   onMouseLeave={() => setHoveredButton(null)}
//                 >
//                   <span
//                     className="absolute inset-0 transition-opacity duration-300"
//                     style={{
//                       background: "rgba(255, 255, 255, 0.15)",
//                       opacity: hoveredButton === 'secondary' ? 1 : 0,
//                     }}
//                   />
//                   <span className="relative z-10 flex items-center justify-center text-lg">
//                     <svg
//                       className="w-5 h-5 mr-2 flex-shrink-0"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
//                     </svg>
//                     <span>Contact Support</span>
//                   </span>
//                 </a>
//               </div>

//               {/* Trust indicators */}
//               <div
//                 className="mt-6 pt-6 border-t flex items-center justify-center gap-6"
//                 style={{
//                   borderColor: "rgba(255, 255, 255, 0.2)",
//                   animation: "fadeIn 0.6s ease-out 1.3s backwards",
//                 }}
//               >
//                 <div className="flex items-center text-white/90 text-sm">
//                   <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" style={{ color: "#FFD700" }}>
//                     <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                   </svg>
//                   100% Secure
//                 </div>
//                 <div className="flex items-center text-white/90 text-sm">
//                   <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" style={{ color: "#FFD700" }}>
//                     <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
//                   </svg>
//                   Quick Process
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes fadeInScale {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         @keyframes slideDown {
//           from {
//             opacity: 0;
//             transform: translateY(-20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes slideInLeft {
//           from {
//             opacity: 0;
//             transform: translateX(-50px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }

//         @keyframes slideInRight {
//           from {
//             opacity: 0;
//             transform: translateX(50px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }

//         @keyframes fadeInLeft {
//           from {
//             opacity: 0;
//             transform: translateX(-20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }

//         @keyframes shimmer {
//           0% {
//             left: -100%;
//           }
//           100% {
//             left: 200%;
//           }
//         }

//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default CTABanner;
import React from "react";

const CTABanner = () => {
  return (
    // <section className="relative py-20 px-6 sm:px-10 bg-transparent">
    //   {/* Dark Blue Glow Background */}
    //   <div className="absolute inset-0 -z-10">
    //     <div className="absolute w-[500px] h-[500px] bg-[#4FA0FF]/20 blur-[130px] rounded-full top-[-100px] left-[-120px]" />
    //     <div className="absolute w-[450px] h-[450px] bg-[#1d8df5]/25 blur-[150px] rounded-full bottom-[-120px] right-[-120px]" />
    //   </div>

    //   {/* Main Container */}
    //   <div className="max-w-6xl mx-auto">
    //     {/* Glass Gradient Card */}
    //     <div className="bg-white/10 backdrop-blur-2xl shadow-xl rounded-3xl p-12 border border-white/20">

    //       {/* Tag */}
    //       <div className="flex justify-center mb-6">
    //         <span className="px-6 py-2 bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] text-white text-sm font-bold rounded-full shadow-lg tracking-wide">
    //           INSTANT APPROVAL • MINIMUM DOCUMENTS
    //         </span>
    //       </div>

    //       {/* Heading */}
    //       <h2 className="text-4xl sm:text-5xl text-center font-extrabold text-black leading-tight mb-4 drop-shadow-lg">
    //         Fast, Secure & Easy Loan Process
    //         <br />
    //         <span className="text-[#4FA0FF]">Designed For Your Needs</span>
    //       </h2>

    //       {/* Description */}
    //       <p className="text-center text-lg text-black max-w-2xl mx-auto mb-12">
    //         Apply anytime and get instant approval with our seamless, digital loan application experience.
    //       </p>

    //       {/* Two-Column Layout */}
    //       <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-10">

    //         {/* Steps Section */}
    //         <div className="bg-white/10 backdrop-blur-xl border border-white/20 shadow-lg rounded-2xl p-8">
    //           <h3 className="text-2xl font-bold text-black mb-6 flex items-center">
    //             <span className="w-2 h-8 bg-[#4FA0FF] rounded-full mr-3"></span>
    //             How It Works
    //           </h3>

    //           <ul className="space-y-6">
    //             {[
    //               "Fill the quick online form",
    //               "Upload your documents securely",
    //               "Receive instant approval & funds",
    //             ].map((step, i) => (
    //               <li key={i} className="flex items-start">
    //                 <div className="w-10 h-10 bg-gradient-to-br from-[#4FA0FF] to-[#1d8df5] text-white/80 flex items-center justify-center rounded-full text-lg font-bold mr-4 shadow-md">
    //                   {i + 1}
    //                 </div>
    //                 <p className="text-lg text-black/90">{step}</p>
    //               </li>
    //             ))}
    //           </ul>
    //         </div>

    //         {/* CTA Buttons */}
    //         <div className="bg-white/10 backdrop-blur-xl border border-white/20 shadow-lg rounded-2xl p-8">
    //           <h3 className="text-2xl font-bold text-black mb-6 flex items-center">
    //             <span className="w-2 h-8 bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] rounded-full mr-3"></span>
    //             Ready to Apply?
    //           </h3>

    //           <div className="space-y-5">
    //             <a
    //               href="/apply-now"
    //               className="block w-full bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] text-white text-lg font-semibold py-4 rounded-xl shadow-lg hover:scale-105 transition-all duration-300 text-center"
    //             >
    //               Apply Now
    //             </a>

    //             <a
    //               href="#contact"
    //               className="block w-full border-2 border-[#4FA0FF] text-[#4FA0FF] text-lg font-semibold py-4 rounded-xl hover:bg-[#4FA0FF] hover:text-white transition-all duration-300 text-center"
    //             >
    //               Contact Support
    //             </a>
    //           </div>

    //           {/* Trust Badges */}
    //           <div className="mt-8 border-t border-white/20 pt-6 flex items-center justify-center gap-8 text-black/70">
    //             <div className="flex items-center gap-2">
    //               <span className="w-3 h-3 bg-[#4FA0FF] rounded-full"></span>
    //               Secure Process
    //             </div>
    //             <div className="flex items-center gap-2">
    //               <span className="w-3 h-3 bg-[#4FA0FF] rounded-full"></span>
    //               Instant Approval
    //             </div>
    //           </div>
    //         </div>

    //       </div>
    //     </div>
    //   </div>
    // </section>
   <section className="relative py-20 px-6 sm:px-10 bg-transparent">
  {/* Background Dark Image */}
  <div
    className="absolute inset-0 -z-20 bg-cover bg-center"
    style={{ backgroundImage: `url('/images/ctabanner1.jpg')` }}
  />

  {/* Dark Blue Glow Background */}
  <div className="absolute inset-0 -z-10">
    <div className="absolute w-[500px] h-[500px] bg-[#4FA0FF]/20 blur-[130px] rounded-full top-[-100px] left-[-120px]" />
    <div className="absolute w-[450px] h-[450px] bg-[#1d8df5]/25 blur-[150px] rounded-full bottom-[-120px] right-[-120px]" />
  </div>

  {/* Main Container */}
  <div className="max-w-6xl mx-auto relative z-10">
    {/* Heading */}
    <div className="text-center mb-12">
      <h2 className="text-4xl sm:text-5xl font-extrabold leading-tight text-white mb-4">
        Fast, Secure & Easy Financial Support
        <br />
        <span className="text-[#4FA0FF]">Designed For Your Needs</span>
      </h2>
      <p className="text-white/70 text-lg max-w-2xl mx-auto">
        Apply anytime and get instant approval with our seamless, digital
        financial support experience.
      </p>
    </div>

    {/* Flex Layout for Left & Right Cards */}
    <div className="flex flex-col md:flex-row gap-10">
      {/* Left Card - Steps Vertical */}
      <div className="flex-1 bg-white/10 backdrop-blur-xl border border-white/20 shadow-lg rounded-2xl p-8 flex flex-col">
        <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
          <span className="w-2 h-8 bg-[#4FA0FF] rounded-full mr-3"></span>
          {"How It Works"}
        </h3>
        <ul className="space-y-6">
          {[
            "Fill the quick online form quickly and easily with minimal effort",
            "Upload your documents securely in just a few steps",
            "Receive instant approval & get support directly into your account",
          ].map((step, i) => (
            <li key={i} className="flex items-start">
              <div className="w-10 h-10 bg-gradient-to-br from-[#4FA0FF] to-[#1d8df5] text-white/80 flex items-center justify-center rounded-full text-lg font-bold mr-4 shadow-md">
                {i + 1}
              </div>
              <p className="text-lg text-white/80">{step}</p>
            </li>
          ))}
        </ul>
      </div>

      {/* Right Card - CTA & Trust */}
      <div
        className="rounded-2xl p-7 border relative overflow-hidden flex flex-col items-center"
        style={{
          background: "rgba(255, 255, 255, 0.05)",
          borderColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
        }}
      >
        {/* Decorative Gradient Circle */}
        <div
          style={{
            position: "absolute",
            bottom: "-50%",
            left: "-50%",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(79,160,255,0.15) 0%, transparent 70%)",
          }}
        />

        {/* Heading */}
        <h3 className="text-2xl font-bold text-white mb-6 flex items-center justify-center">
          <svg
            className="w-7 h-7 mr-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            style={{ color: "#4FA0FF" }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          Ready to Get Started?
        </h3>

        {/* Buttons */}
        <div className="space-y-4 w-full max-w-xs flex flex-col items-center">
          <a
            href="/apply-now"
            className="w-full font-bold rounded-xl shadow-lg transition-all duration-300 flex items-center justify-center min-h-[56px] px-8 bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] text-white text-center"
          >
            <span className="flex items-center justify-center text-lg">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
              Get Started Now
            </span>
          </a>
          <a
            href="#contact"
            className="w-full border-2 font-bold rounded-xl transition-all duration-300 flex items-center justify-center min-h-[56px] px-8 border-[#4FA0FF] bg-transparent text-[#4FA0FF] text-center"
          >
            <span className="flex items-center justify-center text-white text-lg">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
              Contact Support
            </span>
          </a>
        </div>

        {/* Trust indicators */}
        <div
          className="mt-6 pt-6 border-t flex flex-col items-center gap-3 w-full"
          style={{ borderColor: "rgba(79,160,255,0.2)" }}
        >
          <div className="flex items-center text-white/90 text-sm">
            <svg
              className="w-5 h-5 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
              style={{ color: "#4FA0FF" }}
            >
              <path
                fillRule="evenodd"
                d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            100% Secure
          </div>
          <div className="flex items-center text-white/90 text-sm">
            <svg
              className="w-5 h-5 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
              style={{ color: "#4FA0FF" }}
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                clipRule="evenodd"
              />
            </svg>
            Quick Process
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  );
};

export default CTABanner;